import * as React from 'react';
import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { useToggle } from 'usehooks-ts';

import { useSidebar } from '../context';

import { Input } from '@/components/ui/input';

export function ArticleSearch() {
  const { handleSearchArticles, searchValue, setSearchValue } = useSidebar();
  const [searchInteracted, , setSearchInteracted] = useToggle(false);
  const searchInputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (searchInteracted) handleSearchArticles?.(searchValue);
  }, [searchValue, handleSearchArticles, searchInteracted]);

  return (
    <div className="mb-2">
      <Input
        ref={searchInputRef}
        className="h-auto text-subtlest border-border-subtle"
        startIcon={MagnifyingGlass}
        endIcon={searchValue ? X : undefined}
        onEndIconClick={() => {
          setSearchValue('');
          handleSearchArticles?.('');
        }}
        value={searchValue}
        onChange={(e) => {
          const value = e.target.value;
          if (!searchInteracted) {
            setSearchInteracted(true);
          }
          setSearchValue(value);
          if (value.trim() === '') {
            handleSearchArticles('');
            setSearchInteracted(false);
          }
        }}
        placeholder="Find an article"
        aria-label="Find an article"
        type="search"
      />
    </div>
  );
}
